import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { 
  submitSearch, 
  setShowSuccessModal, 
  clearSubmitError,
  resetSearchState,
  selectIsSubmitting,
  selectSubmitError,
  selectShowSuccessModal,
  selectSearchResults,
  selectLastSubmission
} from '../../redux/therapist/matchmakingSlise';
import { AppDispatch } from '../../redux';

export const useSearchSubmission = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  // Select state from Redux store
  const isSubmitting = useSelector(selectIsSubmitting);
  const submitError = useSelector(selectSubmitError);
  const showSuccessModal = useSelector(selectShowSuccessModal);
  const searchResults = useSelector(selectSearchResults);
  const lastSubmission = useSelector(selectLastSubmission);

  // Handle search submission
  const submitMatchMaking = useCallback(async ( formattedData: any, savePreferencesCallback: () => void ) => {
    await savePreferencesCallback();
    return dispatch(submitSearch(formattedData));
  }, [dispatch]);

  // Clear submit error
  const clearError = useCallback(() => {
    dispatch(clearSubmitError());
  }, [dispatch]);

  // Set success modal visibility
  const setSuccessModal = useCallback((show: boolean) => {
    dispatch(setShowSuccessModal(show));
  }, [dispatch]);

  // Reset entire search state
  const resetState = useCallback(() => {
    dispatch(resetSearchState());
  }, [dispatch]);

  return {
    // State
    isSubmitting,
    submitError,
    showSuccessModal,
    searchResults,
    lastSubmission,
    
    // Actions
    submitMatchMaking,
    clearError,
    setSuccessModal,
    resetState
  };
};
